import gql from 'graphql-tag';
const GRAPH_IT_ACTIVITY_FRAGMENT = gql `
  fragment GraphItActivityFragment on GraphItActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
      }
    }
    rounds {
      id
      optionalNumAnswers: numAnswers
      hint {
        id
        audioId
        audio {
          id
          src
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
        }
      }
      questionHtml {
        id
        elements
      }
      chart {
        xAxis {
          id
          label
          minValue
          maxValue
          increment
        }
        yAxis {
          id
          label
          minValue
          maxValue
          increment
        }
        data {
          label
          color
          value
          icon {
            imageId
            image {
              id
              src
            }
          }
        }
      }
      table {
        labelHtml {
          id
          elements
        }
        headers {
          label
          columnType
        }
        rows {
          values {
            value
            correct
          }
        }
      }
      optionalMainContent: mainContent {
        id
        svgId
        svg {
          id
          src
        }
      }
    }
  }
`;
export default GRAPH_IT_ACTIVITY_FRAGMENT;
